// The aligner's menus, the table the shell's menu model takes (src/core/menu.ts): File, Edit, Row,
// View and Help. The application and Window menus stay in it for a system menu bar, which the
// aligner never has, and Open Recent has no place here.

import { placer, type MenuBarTable, type MenuId } from '../../core/menu.ts'

export const MENUS = {
  app: { label: 'Interplae', sections: ['about', 'settings'] },
  file: { label: 'File', sections: ['open', 'save', 'export'] },
  edit: { label: 'Edit', sections: ['history', 'text', 'settings'] },
  row: { label: 'Row', sections: ['structure', 'move', 'lock', 'go', 'review'] },
  view: { label: 'View', sections: ['source', 'target', 'columns'] },
  window: { label: 'Window', sections: [] },
  help: { label: 'Help', sections: ['find', 'about'] },
} as const

export type AlignMenus = typeof MENUS
export type AlignMenuId = MenuId<AlignMenus>

/// The menus in the order a menu bar shows them.
export const BAR: MenuBarTable<AlignMenus> = { menus: MENUS, order: ['app', 'file', 'edit', 'row', 'view', 'window', 'help'] }

/// A command's place in these menus.
export const at = placer(MENUS)
